import DocumentsTypes from '../../resources/enums/DocumentsTypes';
import { IDocumentType } from './types';

export const documentTypesList = [
    {
        name: { en: 'Regulations' },
        code: DocumentsTypes.Regulations,
        id: '1',
    },
] as IDocumentType[];
